<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
        <el-col :span="24">
          <el-form-item label="场所类型" prop="type_id">
            <el-radio-group v-model="form_data.type_id">
              <el-radio :label="parseInt(index)" v-for="(item,index) in PLACE_STATE" :key="index">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="隐患等级" prop="state">
            <el-radio-group v-model="form_data.state">
              <el-radio :label="parseInt(index)" v-for="(item,index) in Grade" :key="index">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="责任人" prop="user_name">
            <el-input type="text" v-model="form_data.user_name" autocomplete="off" :rows="4" maxlength="250" placeholder="请输入责任人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="手机号" prop="user_iphone">
            <el-input type="text" v-model="form_data.user_iphone" autocomplete="off" :rows="4" maxlength="250" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit()" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import {
  PLACE_STATE,Grade
} from './lavel.js';
export default {
  name: 'l-department-info-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    community_id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      PLACE_STATE: PLACE_STATE,
      Grade:Grade,
      //表单数据
      form_data: {
        state: 1,
        type_id: 2,
        user_name: '',
        user_iphone: '',
        id: '',
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    //获取数据
    getData() {
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`communityDuty_details`, { id: this.$props.id }).then((ret) => {
          // console.log(ret)
          this.form_data = ret;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.submitting = true;
      if (!this.hasId) {//添加
        this.form_data.id = this.$props.id;
      }
      this.$_invoke('communityDuty_save', {
        community_id: this.$props.community_id,
        ...this.form_data
      }).then(() => {
        this.$_msg.success('成功');
        this.$emit('on-success');
      }).finally(() => {
        this.submitting = false;
      })

    },
  },
}
</script>